import { Helmet } from "react-helmet";
import { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios'
import { Img, Heading, Button, Input } from "../../components";
import CheckBox from "components/CheckBox"
import Navbar from "components/Navbar";

const apiUrl = process.env.REACT_APP_API_URL;

export default function CreateAccount() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log('api url: ' + apiUrl)
      const response = await axios.post(`${apiUrl}/register`, { firstName, lastName, email, companyName});
      console.log('register ok')
      sessionStorage.setItem("AC_firstName", firstName);  
      sessionStorage.setItem("AC_lastName", lastName);  
      sessionStorage.setItem("AC_email", email);  
      navigate('/createAccount2')
    } catch (err) {
      if (err.response) {
        setError(err.response.data.error);
      } else if (err.request) {
        setError("Network error. Please check your internet connection and try again.");
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
        

      
    }
  };


  return (
    <>
      <Helmet>
        <title>Create Your Account - Start Your Journey</title>
        <meta
          name="description"
          content="Join our community by creating an account. Stay informed with newsletters and take the first step towards a personalized experience."
        />
      </Helmet>
      <div className="w-full">
        <div className="relative h-[798px] bg-gray-900_01">
          <div className="absolute left-1/4 top-[11%] m-auto h-[448px] w-[28%] rotate-[-115deg] rounded-[50%] bg-gradient" />
          <Img
            src="images/img_elipse_blue.png"
            alt="Blue Ellipse"
            className="absolute bottom-[0.82px] right-[26%] m-auto h-[242px] w-[32%] rotate-[-30deg] object-contain"
          />
          <div className="container-xs absolute bottom-0 left-0 right-0 top-0 my-auto flex h-max flex-col gap-[88px] md:gap-[66px] md:px-5 sm:gap-11">
            <Navbar />
          <div>
              <div className="flex flex-col items-start">
                <div className="flex flex-col items-center gap-3 self-stretch p-12 md:p-5">
                  <Heading
                    size="textlg"
                    as="h1"
                    className="w-[30%] text-center text-[20px] font-medium leading-[140%] text-white-a700 md:w-full "
                  >
                    By creating an account, you may receive newsletters or promotions.
                  </Heading>
                  <form onSubmit={handleSubmit} className="flex w-[30%] flex-col items-center gap-3 md:w-full">
                    <Input
                      value={firstName}
                      onChange={(e)=>setFirstName(e.target.value)} 
                      shape="square"
                      type="text"
                      name="FirstName Input"
                      placeholder={`First name`}
                      className="w-full"
                      style={{ backgroundColor: '#262528', border: 'none' }}
                    />
                    <Input
                      value={lastName}
                      onChange={(e)=>setLastName(e.target.value)} 
                      shape="square"
                      type="text"
                      name="LastName Input"
                      placeholder={`Last name`}
                      className="w-full"
                      style={{ backgroundColor: '#262528', border: 'none'  }}
                    />
                    <Input 
                      value={email}
                      onChange={(e)=>setEmail(e.target.value)} 
                      shape="square" 
                      type="email" 
                      name="Email Input" 
                      placeholder={`Email`} 
                      className="w-full"
                      style={{ backgroundColor: '#262528', border: 'none' }}
                      
                    />
                    <Input
                      value={companyName}
                      onChange={(e)=>setCompanyName(e.target.value)} 
                      shape="square"
                      type="text"
                      name="Comanpy Name Input"
                      placeholder={`Company Name`}
                      className="w-full border-0 !text-gray-500 "
                      
                      style={{ backgroundColor: '#262528',border: 'none' }}
                      
                    />
                    {/* 
                    <CheckBox
                      name="Contract Checkbox"
                      label="Sign Contract or NDA"
                      id="ContractCheckbox"
                      className="gap-2 self-start text-[12px] text-white-a700"
                    />
                    */}
                    <Button type="submit" color="indigo_A700" size="sm" shape="square" className="self-stretch px-[34px] sm:px-5">
                      Create accout
                    </Button>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <Heading size="texts" as="h2" className="flex text-[14px] font-medium text-white-a700">
                      <span>Already have an account?&nbsp;</span>
                      <a href="/login" className="inline underline">
                        Sign in
                      </a>
                    </Heading>
                    <Heading
                      as="h3"
                      className="self-stretch text-center text-[8px] font-medium leading-[140%] text-white-a700"
                    >
                      <span>This site is protected by reCAPTCHA and the Google&nbsp;</span>
                      <a href="/doc/Privacy_Policy.docx" className="inline underline">
                        Privacy Policy
                      </a>
                      <span>&nbsp;apply.</span>
                    </Heading>
                  </form>
                </div>
                <div className="relative mt-[-6px] flex items-center gap-[22px] bg-gray-900_02 p-1">
                  <Heading
                    size="texts"
                    as="h4"
                    className="self-end text-[14px] font-medium tracking-[-0.28px] text-gray-400"
                  >
                    Powered by
                  </Heading>
                  <Img src="images/img_settings.svg" alt="Settings Image" className="h-[16px] w-[48%] object-contain" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
